<template>
  <div class="check-token">
    <a-spin tip="Loading..." size="large"></a-spin>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isLoading: true
    }
  },
  methods: {
    // 针对不同环境下的域名拿值
    getValues () {
      const _window = window.top || window.parent || window
      var query = _window.location.href
      query = query.split('?')
      var params = {}
      for (let i = 0; i < query.length; i++) {
        if (!query[i].includes('=')) { // 停止不带参数的部分
          continue
        }
        let paramsLength = query[i].split('&') // 例：code=324ab2dfbe7a301f81cad9b5988bb01d & state=STATE
        for (let a in paramsLength) {
          let obbUrl = paramsLength[a].split('=') // 例：code=324ab2dfbe7a301f81cad9b5988bb01d
          params[obbUrl[0]] = obbUrl[1]
        }
      }
      return params // 返回?号后面的参数名与参数值的数组
    }
  },
  mounted () {
    const _window = window.top || window.parent || window
    this.$store
      .dispatch('GetUserInfo', { reset: true }) // 调用一个接口来校验token是否失效
      .then(() => {
        this.$notification.error({
          message: this.$t('notification-modal.title.prompt'),
          description: this.$t('form-modal.third-party-abnormal')
        })
        _window.location.href = `${_window.location.protocol}//${_window.location.host}/#/user/home`
      })
      .catch(() => { // 跳转登录
        const params = this.getValues()
        const { id } = params
        _window.location.href = `${_window.location.protocol}//${_window.location.host}/login?redirect=%2Ferp%2Fhome%3Fid%3D${id}`
      })
  }
}
</script>
<style lang="less" scoped>
  .check-token {
    width: 100%;
    height: 100%;
    background: #fff;
    min-height: 500px;
    text-align: center;
    display: flex;
    justify-content:center;
    align-items:center;
  }
</style>
